import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffiliateProgramCreativesListItem } from '../types';
import {
  AFFILIATE_PROGRAM_CREATIVES_LIST_API_URL,
  AFFILIATE_PROGRAM_CREATIVES_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS,
} from '../constants';

export default function useAffiliateProgramCreativesListQuery(
  tableState: Ref<ITableState>,
  format: Ref<string>,
  isDisabled: Ref<boolean>,
): IContextQueryResult<ITableDataResponse<IAffiliateProgramCreativesListItem>, Error> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliateProgramCreativesListItem>>({
    queryKey: [AFFILIATE_PROGRAM_CREATIVES_LIST_QUERY_KEY, format, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliateProgramCreativesListItem>>(
      AFFILIATE_PROGRAM_CREATIVES_LIST_API_URL,
      {
        ...tableState.value,
        additional_options: {
          format: format.value,
        },
        format: format.value,
      },
      {
        signal,
        permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
    enabled: computed(() => !isDisabled.value && !!format.value),
  });
}
